import React from 'react';
import './CsvUploadResults.css';

const CsvUploadResults = ({ results, onClose }) => {
  const { added, updated, duplicates, invalid, failed } = results;
  const totalProcessed = (added || 0) + (updated || 0) + (duplicates || 0) + (invalid || 0) + (failed || 0);

  return (
    <div className="csv-results-modal-overlay" onClick={onClose}>
      <div className="csv-results-modal" onClick={(e) => e.stopPropagation()}>
        <div className="csv-results-header">
          <h2>CSV Upload Results</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="csv-results-summary">
          <p>Processed {totalProcessed} total rows</p>
        </div>

        <div className="csv-results-breakdown">
          {added > 0 && (
            <div className="result-item success">
              <div className="result-icon">✓</div>
              <div className="result-details">
                <div className="result-label">Successfully Added</div>
                <div className="result-count">{added} {added === 1 ? 'prospect' : 'prospects'}</div>
              </div>
            </div>
          )}

          {updated > 0 && (
            <div className="result-item info">
              <div className="result-icon">↻</div>
              <div className="result-details">
                <div className="result-label">Updated</div>
                <div className="result-count">{updated} {updated === 1 ? 'prospect' : 'prospects'}</div>
              </div>
            </div>
          )}

          {duplicates > 0 && (
            <div className="result-item warning">
              <div className="result-icon">⚠</div>
              <div className="result-details">
                <div className="result-label">Already in Database</div>
                <div className="result-count">{duplicates} {duplicates === 1 ? 'record already in db' : 'records already in db'}</div>
              </div>
            </div>
          )}

          {(invalid > 0 || failed > 0) && (
            <div className="result-item error">
              <div className="result-icon">✗</div>
              <div className="result-details">
                <div className="result-label">Errors</div>
                <div className="result-count">
                  {(invalid || 0) + (failed || 0)} {((invalid || 0) + (failed || 0)) === 1 ? 'row' : 'rows'}
                </div>
                {invalid > 0 && <div className="result-subtext">Invalid rows: {invalid}</div>}
                {failed > 0 && <div className="result-subtext">Failed to process: {failed}</div>}
              </div>
            </div>
          )}

          {totalProcessed === 0 && (
            <div className="result-item warning">
              <div className="result-icon">ℹ</div>
              <div className="result-details">
                <div className="result-label">No data processed</div>
                <div className="result-subtext">Please check your CSV file format</div>
              </div>
            </div>
          )}
        </div>

        <div className="csv-results-actions">
          <button className="btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default CsvUploadResults;
